export const LIST_CATEGORIES = "LIST_CATEGORIES";
export const DELETE_CATEGORY = "DELETE_PRODUCT";
